<div class="max-w-1500px d-flex flex-dir-column">
    <app-mobile-section-title [text]="contentService.content().mainPage.whyMe.title"></app-mobile-section-title>
    
    <div [ngStyle]="{'display': 'flex'}">
        <app-section-title [title]="contentService.content().mainPage.whyMe.title"
            (click)="triggerScroll('whyMe')"></app-section-title>

        <app-argument-block></app-argument-block>
    </div>

    <app-btn-to-contact [text]="contentService.content().mainPage.whyMe.contactBtn"></app-btn-to-contact>
</div>